import DOMPurify from 'dompurify';

const HTML_TAG_REGEX = /<[a-z][\s\S]*>/i;

// Quill 2 (getSemanticHTML) remplace chaque espace par &nbsp;, ce qui rend le texte insécable
// et provoque des coupures au milieu des mots. On remplace chaque suite d'espaces insécables
// (entité ou caractère U+00A0) par une espace sécable suivie des insécables restantes,
// pour conserver la largeur des suites d'espaces volontaires.
const NBSP_RUN_REGEX = /(?:&nbsp;|&#160;|&#xa0;|\u00A0)+/gi;

const restoreBreakableSpaces = (html: string): string =>
  html.replace(NBSP_RUN_REGEX, run => ' ' + '\u00A0'.repeat((run.match(/&nbsp;|&#160;|&#xa0;|\u00A0/gi)?.length ?? 1) - 1));

export const toSafeMessageHtml = (content: string): string => {
  const html = HTML_TAG_REGEX.test(content) ? content : content.replace(/\\n|\n/g, '<br/>');

  return DOMPurify.sanitize(restoreBreakableSpaces(html));
};
